module.exports = __webpack_public_path__ + "img/statistics.bb016543.svg";